import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryTabs = _resolveComponent("CategoryTabs")!
  const _component_AutobookingForm = _resolveComponent("AutobookingForm")!

  return (_ctx.repairReasons.length > 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_CategoryTabs, {
          "repair-reasons": _ctx.repairReasons,
          "repair-reason-id": _ctx.repairReasonId,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeReason($event)))
        }, null, 8, ["repair-reasons", "repair-reason-id"]),
        (_ctx.initialCategoryId)
          ? (_openBlock(), _createBlock(_component_AutobookingForm, {
              key: 0,
              "data-mechanic-id": _ctx.dataMechanicId,
              "data-web-columns": _ctx.dataWebColumns,
              "data-initial-date": _ctx.dataInitialDate,
              "data-initial-service": _ctx.dataInitialService,
              "data-slots-interval": _ctx.dataSlotsInterval,
              "data-model": _ctx.dataModel,
              "data-brand": _ctx.dataBrand,
              "data-model-id": _ctx.dataModelId,
              "data-brand-id": _ctx.dataBrandId,
              "repair-reason-id": _ctx.repairReasonId,
              "data-mechanic-meta": _ctx.dataMechanicMeta,
              "data-full-autobooking-support": _ctx.dataFullAutobookingSupport,
              "data-bookowarka-flow": _ctx.dataBookowarkaFlow,
              services: _ctx.services,
              "initial-category-id": _ctx.initialCategoryId
            }, null, 8, ["data-mechanic-id", "data-web-columns", "data-initial-date", "data-initial-service", "data-slots-interval", "data-model", "data-brand", "data-model-id", "data-brand-id", "repair-reason-id", "data-mechanic-meta", "data-full-autobooking-support", "data-bookowarka-flow", "services", "initial-category-id"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_ctx.isDataLoaded)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, "Przepraszamy, nie można umówić wizyty."))
      : _createCommentVNode("", true)
}